import { ActionType } from "../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../react-core/Flux/Dispatcher";
import { ReRegTransferStoreStatic } from "./ReRegTransferStoreStatic";
import { SelectedInvestmentStoreStatic } from "./SelectedInvesmentStoreStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const SelectedInvestmentDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const SelectedInvestmentStore: SelectedInvestmentStoreStatic = new SelectedInvestmentStoreStatic();

export const ReRegTransferDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ReRegTransferStore: ReRegTransferStoreStatic = new ReRegTransferStoreStatic();
